import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import '../../styles/TermsAndConditions.css'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import { ReactComponent as Checkbox } from '../../assets/svg/checkbox/Checkbox.svg'
import { ReactComponent as CheckboxEmpty } from '../../assets/svg/checkbox/CheckboxEmpty.svg'
import { ENGLISH_ALERTS_MODAL_TEXT, GERMAN_ALERTS_MODAL_TEXT } from '../alerts/constants/AlertsConstants.js'
import { agreeToAlertTerms } from '../../server/server.js'
import { useUser } from '../../auth/index.js'

function AlertsModal({ modalIsOpen, closeModal }) {
    const { t, locale } = useTranslation()
    const { user, setUser } = useUser()
    const [agree, setAgree] = useState(false)

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    const _closeModal = async () => {
        agreeToAlertTerms()
        setUser({ ...user, alert_terms: true })
        // const skip = localStorage.getItem('skip-alerts-info')
        // if (skip == null && agree) localStorage.setItem('skip-alerts-info', true)
        closeModal()
    }

    return (
        <ReactModal
            transparent
            closeTimeoutMS={600}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            className="noScroll"
            style={{
                overlay: {
                    zIndex: 0,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 490,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                },
            }}
        >
            <div className="student-info-modal">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="close-modal-icon " onClick={() => closeModal()}>
                        <CloseModalIcon />
                    </div>
                </div>
                <div className="mt-7">
                    <p className="text-[#010101] text-[30px] leading-[37.5px] font-bold ">{t('AI-Powered Wellbeing Alerts – Important Notice')} </p>

                    <Markdown className="markdown" remarkPlugins={[remarkGfm]}>
                        {i18n.language === 'de' ? GERMAN_ALERTS_MODAL_TEXT : ENGLISH_ALERTS_MODAL_TEXT}
                    </Markdown>
                </div>
                {/* <div className="flex flex-row items-center mt-8">
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', backgroundColor: 'transparent', paddingRight: 10 }} onClick={() => setAgree(!agree)}>
                        {agree ? <Checkbox /> : <CheckboxEmpty />}
                    </div>
                    <div className="text-deepPurple text-[16px] leading-5 font-semibold cursor-pointer" onClick={() => setAgree(!agree)}>
                        {t("Don't show me this in the future")}
                    </div>
                </div> */}
                <div className="flex items-center justify-center w-full mt-10">
                    <button className="flex items-center justify-center w-[342px] h-[50px] rounded-full bg-deepPurple hover:bg-darkenPurple" onClick={_closeModal}>
                        <p className="text-highlightColor text-[18px] leading-[22.5px] font-semibold">{t('I Understand')}</p>
                    </button>
                </div>
            </div>
        </ReactModal>
    )
}

export default AlertsModal
